module.exports = __webpack_public_path__ + "static/media/arrow-icon.3097f7b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/arrow-icon.svg
// module id = 513
// module chunks = 0